// extracted by mini-css-extract-plugin
export var backupIcon = "_st-1";
export var image = "_st-0";